module.exports = __webpack_public_path__ + "img/dashboard.32aa3efc.png";